export default "__VITE_ASSET__CXlOgcL6__"